import React from 'react'
import PropTypes from 'prop-types'
import {Box, Flex} from '@chakra-ui/react'

import Alert from '../Alert'

const NotificationBanner = ({status, title, message, ctaButton, onClose}) => {
  const messageContent = ctaButton ? (
    <Flex justify="space-between" alignItems="flex-start" width="100%">
      <Flex direction="column" gap="xxs" flex="1">
        {title && (
          <Box textStyle="body-intro-medium" textWrap="wrap">
            {title}
          </Box>
        )}
        <Box>{message}</Box>
      </Flex>
      <Box ml="md" mr="md" flexShrink={0} my="auto">
        {ctaButton}
      </Box>
    </Flex>
  ) : (
    message
  )

  return (
    <Alert
      className="fs-unmask"
      status={status}
      isDismissable
      title={ctaButton ? null : title}
      message={messageContent}
      onClose={onClose}
    />
  )
}

NotificationBanner.propTypes = {
  status: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  ctaButton: PropTypes.element,
  onClose: PropTypes.func,
}

NotificationBanner.defaultProps = {
  ctaButton: null,
  onClose: () => {},
}

export default NotificationBanner
